import React from "react";
//#region types
import { DrillDownTableChildrenRowsProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import DrillDownTableRow from "./row";

//#endregion

const DrillDownTableRowChildren: React.FC<DrillDownTableChildrenRowsProps> = (props) => {
  const { rows, depth, parentIndex, path } = props;

  const hasExpandableSiblingRow = props.childrenKey ? rows.some((row) => row[props.childrenKey]?.length) : false;

  return (
    <>
      {rows.map((row, childRowIndex) => (
        <DrillDownTableRow
          {...props}
          key={`tab-row-${depth + 1}-${childRowIndex}`}
          row={row}
          index={childRowIndex}
          parentIndex={parentIndex}
          path={[...path, parentIndex]}
          depth={depth + 1}
          noExpandableSiblingRows={!hasExpandableSiblingRow}
        />
      ))}
    </>
  );
};

export default DrillDownTableRowChildren;
